import React from "react";
import { NumericFormat } from "react-number-format";

export const PercentFormatInputDefault = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      suffix="%"
      fixedDecimalScale
      valueIsNumericString
      allowNegative // Permite números negativos
      onValueChange={(values) => {
        const { value } = values;
        const numericValue = parseFloat(value);

        if (isNaN(numericValue)) {
          onChange({
            target: {
              name: props.name,
              value: "",
            },
          });
          return;
        }

        // Agora permite valores entre -100 e 100
        if (numericValue >= -100 && numericValue <= 100) {
          onChange({
            target: {
              name: props.name,
              value: numericValue,
            },
          });
        }
      }}
      isAllowed={({ floatValue }) => {
        // Permite valores entre -100 e 100
        return floatValue === undefined || (floatValue >= -100 && floatValue <= 100);
      }}
    />
  );
});


export const PercentFormatInputFive = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      suffix="%"
      fixedDecimalScale
      valueIsNumericString
      allowNegative // Permite números negativos
      onValueChange={(values) => {
        const { value } = values;
        const numericValue = parseFloat(value);

        if (isNaN(numericValue)) {
          onChange({
            target: {
              name: props.name,
              value: "",
            },
          });
          return;
        }

        // Agora permite valores entre -100 e 100
        if (numericValue >= -100 && numericValue <= 100) {
          onChange({
            target: {
              name: props.name,
              value: numericValue,
            },
          });
        }
      }}
      isAllowed={({ floatValue }) => {
        // Permite valores entre -100 e 100
        return floatValue === undefined || (floatValue >= -100 && floatValue <= 100);
      }}
    />
  );
});